<template>
    <el-dialog title="Changer le Vehiculier" v-loading="loader" :visible.sync="display" width="50%">
        <div class="mb-3">Modifier les {{ items_selected }} produits selectionnés</div>
        <el-form class="formChangeVehicule" ref="form" :model="form">
            <vehicule-cascader class="full-width" v-model="form.vehicule"></vehicule-cascader>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="warning" @click="removeVehicule" plain>Enlever</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            vehiculeOptions: [],
            form: {
                vehicule: []
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            if (!this.form.vehicule.length) {
                return;
            }
            var products = this.selected.map(v => v.id);
            this.loader = true;
            var vehicule = this.form.vehicule;
            var datas = {
                products,
                vehicule,
                mode: 'change_vehicule'
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            axios
                .post('/products/bulk', datas)
                .then(r => {
                    this.$emit('saved', r);
                    this.$refs.form.resetFields();
                    this.display = false;
                    if (this.filters.hasVehicule !== null) {
                        this.validFilters();
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        },
        removeVehicule() {
            this.$confirm('Enlever le véhicule aux produits ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    var products = this.selected.map(v => v.id);
                    this.loader = true;
                    var datas = {
                        products,
                        mode: 'remove_vehicule'
                    };
                    if (this.applyToAllResult) {
                        datas.filters = this.filters;
                    }
                    datas.total_item = this.total_item
                    datas.items_selected = this.items_selected
                    axios
                        .post('/products/bulk', datas)
                        .then(r => {
                            this.$emit(
                                'productsUpdated',
                                Product.build(r.data.data)
                            );
                            this.$emit('saved', r);
                            this.display = false;
                            if (this.filters.hasVehicule !== null) {
                                this.validFilters();
                            }
                        })
                        .catch(() => {})
                        .then(() => {
                            this.loader = false;
                        });
                })
                .catch(() => {});
        }
    }
};
</script>
